import { NavLink } from "react-router-dom";
import classNames from "classnames";
import { PropsWithChildren } from "react";

type Props = {
	link: string
	onClick?: () => void
}

function HeaderLink({
	link,
	children,
	onClick,
}: PropsWithChildren<Props>) {
	return (
		<li>
			<NavLink
				to={ link }
				className={ ({ isActive }) => classNames("text-stone-50 header-link", { "header-link--active": isActive }) }
				onClick={ onClick }
			>
				{ children }
			</NavLink>
		</li>
	);
}

export default HeaderLink;